import auth from "@/middleware/auth";

export default [
  {
    path: "propostas-tribanco/:contractId",
    name: "propostasTribanco",
    meta: { middleware: [auth] },
    component: () => import("./PropostasTribanco"),
  },
];
